<!--
 * @Author: lzh
 * @Date: 2021-07-30 09:54:04
 * @LastEditors: lzh
 * @LastEditTime: 2021-09-07 12:09:51
 * @Description: file content
-->
<template>
  <van-tabbar
    class="self_footnav"
    v-model="navIndex"
    v-if="navIndex >= 0"
    safe-area-inset-bottom
    :active-color="color"
    :z-index="100"
  >
    <van-tabbar-item
      v-for="(item, index) in navList"
      :key="index"
      @click="tab(item.routerName)"
    >
      <span v-html="item.name"></span>
      <div
        class="icon self_bg_color"
        slot="icon"
        slot-scope="props"
        :style="{
          'background-image':
            'url(' + (props.active ? item.activeIcon : item.icon) + ')'
        }"
      ></div>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import lang_ from "@/js/locales";
export default {
  name: "footNav",
  data() {
    return {
      navList: [
        {
          name: "會員卡",
          icon: require("@/assets/huiyuanqia.png"),
          activeIcon: require("@/assets/huiyuanqia_active.png"),
          routerName: "vipCard"
        },
        {
          name: "品牌",
          icon: require("@/assets/pinpai.png"),
          activeIcon: require("@/assets/pinpai_active.png"),
          routerName: "brand"
        },
        {
          name: "我的賬戶",
          icon: require("@/assets/account.png"),
          activeIcon: require("@/assets/account_active.png"),
          routerName: "my"
        }
      ],
      navIndex: -1,
      color: ""
    };
  },
  watch: {
    $route() {
      this.init_lang();
      this.setNavIndex();
    }
  },
  created() {
    this.init_lang();
    this.setNavIndex();
    this.color = this.themeColor;
  },
  methods: {
    init_lang() {
      this.navList[0].name = lang_.t("Membership");
      this.navList[1].name = lang_.t("Shop");
      this.navList[2].name = lang_.t("Profile");
    },
    setNavIndex() {
      this.navIndex = -1;
      this.navList.map((item, index) => {
        if (item.routerName == this.$route.name) this.navIndex = index;
      });
    },
    tab(name) {
      console.log("name", name);
      this.$router.tab({
        name: name,
        params: {
          arg: this.$route.params.arg
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/footNav.vue